import React from 'react';
import './radiobox.scss';

const RadioBox = ({ isChecked, onChange, value, name, }) => {
  return (
    <div>
      <input
        onChange={onChange}
        checked={isChecked}
        className="submit-check-input"
        type="radio"
        value={value}
        name={name}
      />
    </div>
  );
};

export default RadioBox;
